import type { ReactNode } from 'react';
import { Tabs } from '@cloudflare/kumo';

export interface AppTab {
  id: string;
  label: ReactNode;
  content?: ReactNode;
}

interface AppTabsProps {
  activeTabId?: string;
  onChange: (e: { detail: { activeTabId: string } }) => void;
  tabs: AppTab[];
  ariaLabel?: string;
  disableContentPaddings?: boolean;
}

/** Abas com conteúdo: o Kumo renderiza só a lista, então o painel ativo fica aqui. */
export function AppTabs({ activeTabId, onChange, tabs, ariaLabel, disableContentPaddings }: AppTabsProps) {
  const active = tabs.find((t) => t.id === activeTabId) ?? tabs[0];
  return (
    <div aria-label={ariaLabel}>
      <Tabs
        variant="underline"
        value={active?.id}
        onValueChange={(v: string) => onChange({ detail: { activeTabId: v } })}
        tabs={tabs.map((t) => ({ value: t.id, label: t.label }))}
      />
      {active?.content != null && <div className={disableContentPaddings ? '' : 'pt-4'}>{active.content}</div>}
    </div>
  );
}
